import { BlockEditor } from '../../containers/blockEditor';
import { Switch } from 'antd';
import { Crud } from '../../containers/crud/crud';
import { CrudForm } from '../../containers/crud/crudForm';
import { translate } from '../../../localization';
import { UpdateEntity } from '../../containers/updateEntity';
import { useCrudData } from '../../containers/crud/crudContext';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { WebCrud } from '../../containers/crud/webCrud';
export default function Job() {
  const { refresh } = useCrudData();
  return (
    <WebCrud
      api="job"
      FormComponent={(props) => (
        <CrudForm
          {...props}
          elements={[
            {
              type: 'file',
              name: 'image',
              label: translate('job.image'),
              required: true,
              fileCode: 'mediaFile',
            },
            {
              type: 'text',
              name: 'title',
              label: translate('job.title'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'text',
              name: 'shortDescription',
              label: translate('job.shortDescription'),
              required: true,
              inputProps: {
                maxLength: 500,
              },
            },
            {
              type: 'custom',
              Component: BlockEditor,
              name: 'description',
              label: translate('job.description'),
              required: true,
            },
            {
              type: 'text',
              name: 'location',
              label: translate('job.location'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'text',
              name: 'type',
              label: translate('job.type'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'text',
              name: 'category',
              label: translate('job.category'),
              required: true,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'text',
              name: 'perfexProjectId',
              label: translate('job.perfexProjectId'),
              required: false,
              inputProps: {
                maxLength: 200,
              },
            },
            {
              type: 'switch',
              name: 'published',
              label: translate('job.published'),
              required: false,
            },
            {
              type: 'switch',
              name: 'featured',
              label: translate('job.featured'),
              required: false,
            },
          ]}
        />
      )}
    >
      <Crud.Header title="Jobs">
        <Crud.Header.Actions.Common>
          <Crud.Header.Actions.Add
            modalProps={{
              className: 'large',
            }}
          />
        </Crud.Header.Actions.Common>
      </Crud.Header>
      <Crud.Table
        actions={[
          ...Crud.Table.RowActions.Common,
          () => (
            <Crud.Table.RowActions.DuplicateRecordWithForm
              elements={[
                {
                  type: 'text',
                  label: 'Enter new title',
                  name: 'title',
                  inputProps: {
                    placeholder: 'title',
                  },
                },
              ]}
            />
          ),
        ]}
        columns={[
          {
            title: translate('common.title'),
            dataIndex: 'title',
          },
          {
            title: 'Type',
            dataIndex: 'type',
          },
          {
            title: 'Category',
            dataIndex: 'category',
          },
          {
            title: 'Location',
            dataIndex: 'location',
          },
          {
            title: 'Featured',
            dataIndex: 'featured',
            render: (value, record) => {
              return (
                <UpdateEntity
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.featured}
                        onChange={async (checked) => {
                          await updateEntity({ featured: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
          {
            title: 'Published',
            dataIndex: 'published',
            render: (value, record) => {
              return (
                <UpdateEntity
                  record={record}
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.published}
                        onChange={async (checked) => {
                          await updateEntity({ published: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
          {
            title: 'Published At',
            dataIndex: 'createdAt',
            render: (text) => {
              return formatDate(text);
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                name: 'title',
                type: 'text',
                inputProps: {
                  placeholder: translate('common.title'),
                },
              },
              {
                name: 'shortDescription',
                type: 'text',
                inputProps: {
                  placeholder: translate('job.shortDescription'),
                },
              },
              {
                label: translate('job.published'),
                name: 'published',
                type: 'custom',
                Component: Switch,
              },
              {
                label: translate('job.featured'),
                name: 'featured',
                type: 'custom',
                Component: Switch,
              },
            ]}
          ></Crud.Search>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
